window.tinymce.PluginManager.add('customlinks', function (editor) {
  var customTags = ['picembed'];

  var addLinksToCustomTags = function (data, editor) {
    var nodeName = editor.selection.getNode().nodeName;
    data = data.value;

    // tag not supported
    if (!customTags.includes(nodeName.toLowerCase())) {
      return;
    }

    var linkAttrs = {
      href: data.href,
      target: data.target || null,
      rel: data.rel || null,
      class: data['class'] || null,
      title: data.title || null,
    };
    // get html content
    var content = editor.selection.getContent();

    // wrap content in a tag
    var aTag = editor.dom.createHTML('a', linkAttrs, content);

    editor.selection.setContent(aTag);
  };

  // listen for commands
  editor.on('ExecCommand', function (data) {
    switch (data.command) {
      case 'mceInsertLink':
        addLinksToCustomTags(data, editor);
        break;
      default:
        return;
    }
  });
});
